import { Component } from '@angular/core';

@Component({
  selector: 'app-ca-tos-contents',
  templateUrl: './ca-tos-contents.component.html',
})
export class CatalanTOSContentsComponent {}
